"use client"

import React from "react"

import { useState, useEffect } from "react"
import { Dialog, DialogTitle, DialogContent, IconButton, List, ListItem, Radio, Typography, Slide } from "@mui/material"
import { X } from "lucide-react"

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export const ListModal = ({
  open,
  onClose,
  title = "Elige aqui",
  options = [],
  onSelect,
  helperText = "Toca para seleccionar un elemento",
}) => {
  const [selectedValue, setSelectedValue] = useState(null)

  useEffect(() => {
    if (!open) {
      // Reset selection when modal closes
      setSelectedValue(null)
    }
  }, [open])

  const handleSelect = (value) => {
    setSelectedValue(value)
    if (onSelect) {
      onSelect(value)
    }
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      PaperProps={{
        style: {
          backgroundColor: "#1F2C34", // Fondo oscuro
          color: "#FFFFFF",
          margin: 0,
          borderRadius: "8px",
          width: "80%", // Ancho del 80% del contenedor
          maxWidth: "400px", // Limita el ancho máximo
          maxHeight: "60%", // Limita la altura al 60% de la pantalla
          position: "absolute",
          top: "20%", // Posiciona el modal al 20% desde arriba
        },
      }}
      container={document.getElementById("chat-modal-container")} // Asegura que se monte dentro del contenedor de ChatInterface
      BackdropProps={{
        style: { backgroundColor: "transparent" }, // Hace que el fondo sea transparente
      }}
    >
      <DialogTitle
        style={{
          display: "flex",
          alignItems: "center",
          padding: "16px",
          borderBottom: "1px solid rgba(255,255,255,0.1)",
        }}
      >
        <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close" style={{ marginRight: "16px" }}>
          <X size={24} />
        </IconButton>
        <Typography variant="h6" style={{ flex: 1, textAlign: "center" }}>
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent style={{ padding: 0 }}>
        <List>
          {options.map((option, index) => (
            <ListItem
              key={index}
              button
              onClick={() => handleSelect(option.id)}
              style={{
                borderBottom: "1px solid rgba(255,255,255,0.05)",
                padding: "16px",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  {option.icon && <span style={{ marginRight: "12px", fontSize: "20px" }}>{option.icon}</span>}
                  <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
                    {option.title}
                  </Typography>
                </div>
                {option.description && (
                  <Typography
                    variant="body2"
                    style={{
                      color: "rgba(255,255,255,0.7)",
                      marginTop: "4px",
                      marginLeft: option.icon ? "32px" : 0,
                    }}
                  >
                    {option.description}
                  </Typography>
                )}
              </div>
              <Radio
                checked={selectedValue === option.id}
                onChange={() => handleSelect(option.id)}
                value={option.id}
                name="radio-buttons"
                inputProps={{ "aria-label": option.title }}
                style={{
                  color: "rgba(255,255,255,0.7)",
                  "&.Mui-checked": {
                    color: "#00A884",
                  },
                }}
              />
            </ListItem>
          ))}
        </List>
        <Typography
          variant="body2"
          align="center"
          style={{
            padding: "16px",
            color: "rgba(255,255,255,0.5)",
            marginTop: "8px",
          }}
        >
          {helperText}
        </Typography>
      </DialogContent>
    </Dialog>
  )
}

export default ListModal

